type Tagged = { type?: string };

export const tagsAllowedForTypes = <T extends Tagged>(
  tags: T[],
  tagTypes?: readonly string[] | null
): T[] => {
  if (!tagTypes?.length) {
    return tags;
  }
  const allowed = new Set(tagTypes);
  return tags.filter((tag) => tag.type != null && allowed.has(tag.type));
};
